module.exports = __webpack_public_path__ + "media/images/tooltip-fe1b269ab9f0fdca65271948b979eeac.svg";